var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfoUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.001 9H12.001C10.8964 9 10.001 9.89543 10.001 11V37C10.001 38.1046 10.8964 39 12.001 39H36.001C37.1055 39 38.001 38.1046 38.001 37V11C38.001 9.89543 37.1055 9 36.001 9Z",
    fill: "#79E7A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9375 24H16.625C15.7275 24 15 24.7275 15 25.625C15 26.5225 15.7275 27.25 16.625 27.25H19.9375C20.835 27.25 21.5625 26.5225 21.5625 25.625C21.5625 24.7275 20.835 24 19.9375 24Z",
    fill: "#E5FFF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.375 17H16.625C15.7275 17 15 17.7275 15 18.625C15 19.5225 15.7275 20.25 16.625 20.25H31.375C32.2725 20.25 33 19.5225 33 18.625C33 17.7275 32.2725 17 31.375 17Z",
    fill: "#E5FFF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0474 30.585C33.2465 30.585 35.8399 27.9916 35.8399 24.7925C35.8399 21.5934 33.2465 19 30.0474 19C26.8483 19 24.2549 21.5934 24.2549 24.7925C24.2549 27.9916 26.8483 30.585 30.0474 30.585Z",
    fill: "#02C551"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0002 42.9996H21.0777C20.7775 42.9998 20.4812 42.9325 20.2106 42.8026C19.94 42.6727 19.7021 42.4835 19.5146 42.2492C19.3271 42.0148 19.1947 41.7412 19.1273 41.4488C19.0599 41.1563 19.0591 40.8524 19.1252 40.5596C20.2227 35.5171 24.6927 32.0596 30.0402 32.0596C35.3877 32.0596 39.8552 35.5046 40.9527 40.5596C41.0187 40.8524 41.018 41.1563 40.9506 41.4488C40.8832 41.7412 40.7508 42.0148 40.5633 42.2492C40.3757 42.4835 40.1378 42.6727 39.8673 42.8026C39.5967 42.9325 39.3003 42.9998 39.0002 42.9996Z",
    fill: "#02C551"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoUser);
export default __webpack_public_path__ + "static/media/icon_info_user.bd38ddf7.svg";
export { ForwardRef as ReactComponent };